import React from "react";
import moment from "moment";

const SimpleDateView = ({ date = null, className = "date" }) => {
  return <span className={className}>{moment(date).format("LLL")}</span>;

  //   if (date === null) return null;
  //   const days = moment()
  //     .startOf("day")
  //     .diff(moment(date).startOf("day"), "days");
  //   let dateName = date;
  //   if (days === 0) {
  //     const hours = moment().diff(moment(date), "hours");
  //     if (hours < 1) {
  //       let minutes = moment().diff(moment(date), "minutes");
  //       if (minutes < 5) {
  //         dateName = "조금전";
  //       } else {
  //         dateName = minutes + "분전";
  //       }
  //     } else if (hours < 12) {
  //       dateName = hours + "시간전";
  //     } else {
  //       dateName = "오늘 " + moment(date).format("LT");
  //     }
  //   } else if (days === 1) {
  //     dateName = "어제 " + moment(date).format("LT");
  //   } else if (days < 7) {
  //     dateName = "이번주";
  //   } else if (days < 30) {
  //     dateName = days + "일전";
  //   } else if (days < 40) {
  //     dateName = "한달전";
  //   } else {
  //     dateName = moment(date).format("LLL");
  //   }

  //   return <span className={className}>{dateName}</span>;
};

export default SimpleDateView;
